// ++++++++++++ Filter data +++++++++++
export const filterOptions = [
  {
    name: "expected_delivery_date",
    label: "Expected Delivery Date",
    type: "date",
  },
  {
    name: "brand",
    label: "Brand",
    type: "text",
  },
  {
    name: "atc_code",
    label: "ATC Code",
    type: "text",
  },
  {
    name: "name",
    label: "Name",
    type: "text",
  },
  {
    name: "supplier",
    label: "Supplier",
    type: "text",
  },
  {
    name: "delivery_status",
    label: "Delivery Status",
    type: "radio",
    options: [
      { label: "Accepted", value: "accepted" },
      { label: "Rejected", value: "rejected" },
      { label: "Pending", value: "pending" },
      { label: "Shipped", value: "shipped" },
      { label: "Received", value: "received" },
    ],
  },
];

export const StockReportfilterOptions = [
  {
    name: "atc_code",
    label: "ATC Code",
    type: "text",
  },
  {
    name: "packaging_type",
    label: "Packaging type",
    type: "text",
  },
];

export const ExpiredDrugsfilterOptions = [
  {
    name: "atc_code",
    label: "ATC Code",
    type: "text",
  },
  {
    name: "batch_number",
    label: "Batch Number",
    type: "text",
  },
];

const currentYear = new Date().getFullYear();

const yearOptions = Array.from({ length: 3 }, (_, i) => {
  const yr = currentYear - i;
  return { label: yr.toString(), value: yr.toString() };
});

export const FinancialfilterOptions = [
  {
    name: "year",
    label: "Year",
    type: "radio",
    options: yearOptions,
  },
];

export const auditTrailOptions = [
  {
    name: "Action",
    label: "Action",
    type: "radio",
    options: [
      { label: "Create", value: "CREATE" },
      { label: "Sale Transaction", value: "SALE_TRANSACTION" },
      { label: "Allocation", value: "ALLOCATION_CREATED" },
      { label: "Rejection", value: "REJECTION" },
      { label: "Disbursement", value: "DISBURSEMENT" },
      { label: "Alart resolve", value: "ALERT_RESOLVED" },
    ],
  },
  {
    name: "user",
    label: "User",
    type: "text",
  },
  {
    name: "date_range",
    label: "Date",
    type: "date",
  },
];
